import { Component, input } from '@angular/core';
import { InfoBoxComponent } from '../../internal/info-box/info-box.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [InfoBoxComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  headerText = input<string>('');
  infoText = input<string>('');
}
